import { render, staticRenderFns } from "./icon-tick-circle.vue?vue&type=template&id=ee6ea62a"
import script from "./icon-tick-circle.vue?vue&type=script&setup=true&lang=ts"
export * from "./icon-tick-circle.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports